var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    { attrs: { gutter: 10 } },
    [
      _c("el-col", { attrs: { xs: 0, sm: 6, md: 8, lg: 8, xl: 8 } }, [
        _vm._v(" "),
      ]),
      _vm._v(" "),
      _c("el-col", { attrs: { xs: 24, sm: 12, md: 8, lg: 8, xl: 8 } }, [
        _c("div", { staticStyle: { "margin-top": "15px" } }, [
          _c("div", [
            _c(
              "h1",
              {
                staticStyle: {
                  "font-size": "22px",
                  "line-height": "1.4",
                  "margin-bottom": "14px",
                  "font-weight": "500",
                  "margin-left": "20px",
                },
              },
              [_vm._v("海丰集运简介")]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticStyle: { "margin-left": "20px" } }, [
            _c("span", { staticClass: "subtitle" }, [_vm._v("SITCLINE")]),
            _vm._v(" "),
            _c(
              "span",
              {
                staticStyle: {
                  color: "#576B95",
                  display: "inline-block",
                  "vertical-align": "middle",
                  "font-size": "15px",
                },
              },
              [_vm._v("海丰集运")]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "subtitle" }, [
              _vm._v("2025年07月03日 09：51"),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { "text-align": "center", margin: "15px" } },
            [
              _c("img", {
                staticStyle: { width: "100%", "max-width": "500px" },
                attrs: { src: require("@/assets/img/banner.webp") },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "contentMain", staticStyle: { margin: "15px" } },
            [
              _c("div", [
                _c("p", [
                  _vm._v(
                    "As of Dec 31, 2024, SITC operates 114 vessels (100 owned and 14 leased), and the service network covers 81 major ports and 78 trade lines."
                  ),
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "The container transportation volume exceeded 3.57 million TEU in 2024（excluding None-charge containers）."
                  ),
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v("One of the major carriers in Intra-Asia market."),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    " As of Dec 31, 2024,our container shipping services cover:"
                  ),
                ]),
                _vm._v(" "),
                _c("ul", [
                  _c("li", [
                    _vm._v(
                      " • 22 ports in Mainland China, with 197 port callings per week;"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      " • 15 ports in Japan, with 103 port callings per week;"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      " • 4 ports in Korea, with 22 port callings per week;"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      " • 29 ports in ASEAN countries, with 125 port callings per week;"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      " • 4 ports in Taiwan, with 16 port callings per week;"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(" • Hong Kong with 10 port callings per week;"),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      " • 1 port in Bangladesh, with 2 port calling per week;"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(" • 4 port in India, with 6 port calling per week."),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("p", [
                  _vm._v(
                    "截止2024年12月31日，公司经营114艘船舶（自有100艘，租赁14艘），挂靠81个主要港口、78条贸易航线。"
                  ),
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "2024年全年海上集装箱运量超过357万标准箱（不含空箱）。"
                  ),
                ]),
                _vm._v(" "),
                _c("p", [_vm._v("亚洲区域航线主力承运人之一。")]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("p", [
                  _vm._v(" 截止2024年12月31日，我们的集装箱航运服务覆盖："),
                ]),
                _vm._v(" "),
                _c("ul", [
                  _c("li", [_vm._v(" • 中国大陆22个港口，每周靠港197次；")]),
                  _vm._v(" "),
                  _c("li", [_vm._v(" • 日本15个港口，每周靠港103次；")]),
                  _vm._v(" "),
                  _c("li", [_vm._v(" • 韩国4个港口，每周靠港22次；")]),
                  _vm._v(" "),
                  _c("li", [_vm._v(" • 东盟国家29个港口，每周靠港125次；")]),
                  _vm._v(" "),
                  _c("li", [_vm._v(" • 中国台湾4个港口，每周靠港16次；")]),
                  _vm._v(" "),
                  _c("li", [_vm._v(" • 中国香港，每周靠港10次；")]),
                  _vm._v(" "),
                  _c("li", [_vm._v(" • 孟加拉1个港口，每周靠港2次；")]),
                  _vm._v(" "),
                  _c("li", [_vm._v(" • 印度4个港口，每周靠港6次。")]),
                ]),
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("br"),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("el-col", { attrs: { xs: 0, sm: 6, md: 8, lg: 8, xl: 8 } }, [
        _vm._v(" "),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }